<template>
  <div style="font-size: 12px; margin-top: 30px">
    <div class="generalContent">
      <div class="header-logo">
        <div class="contentImg">
          <div>
            <label class="logo" for="input_file">
              <span class="d-flex">
                <p
                  style="padding: 0; margin: 0"
                  :hidden="imgBase64 || dataCompany.urlImage"
                >
                  Selecione sua logo
                </p>
                <img
                  :hidden="!dataCompany.urlImage && !imgBase64"
                  :class="classImg"
                  :src="
                    dataCompany.urlImage
                      ? `${dataCompany.urlImage}?timestamp=${Date.now()}`
                      : imgBase64
                  "
                />
              </span>
            </label>
            <input type="file" id="input_file" @change="selectImage" />
          </div>
        </div>
        <div class="cards-grid">
          <div style="display: flex; flex-direction: column; gap: 5px">
            <button
              v-if="handleVerifyUserLevel"
              @click="openModals('modalManagementCompany')"
              name="user"
              class="report-card"
              style="border-left: 3px solid #3e66ae"
            >
              <div
                class="icon-wrapper"
                style="color: #3e66ae; background-color: #edf1fc"
              >
                <b-icon-building></b-icon-building>
              </div>
              <div class="card-content">
                <span class="card-title">Gerenciamento de empresas</span>
                <span class="card-description"
                  >Configure empresas e unidades de negócio.</span
                >
              </div>
            </button>
            <button
              v-if="handleVerifyUserLevel"
              @click="$bvModal.show('modal-support-art-password')"
              class="report-card"
              style="border-left: 3px solid #006458"
            >
              <div
                class="icon-wrapper"
                style="color: #006458; background: #edfcf2"
              >
                <b-icon-pencil-square />
              </div>
              <div class="card-content">
                <span class="card-title">Corrigir ART das receitas</span>
                <span class="card-description"
                  >Acesso restrito ao suporte.</span
                >
              </div>
            </button>
          </div>
          <div style="display: flex; flex-direction: column; gap: 5px">
            <button
              v-if="handleVerifyUserLevel"
              @click="handleModals('logsScreen')"
              class="report-card"
              style="border-left: 3px solid #fba849"
            >
              <div
                class="icon-wrapper"
                style="color: #fba849; background-color: #fcfaed"
              >
                <b-icon-book></b-icon-book>
              </div>
              <div class="card-content">
                <span class="card-title">Registros</span>
                <span class="card-description"
                  >Consulte os registros do sistema.</span
                >
              </div>
            </button>
            <button
              v-if="handleVerifyUserLevel"
              @click="findPlan()"
              name="control"
              class="report-card"
              style="border-left: 3px solid #403b74"
            >
              <div
                class="icon-wrapper"
                style="color: #403b74; background-color: #f3edfc"
              >
                <b-icon-lock></b-icon-lock>
              </div>
              <div class="card-content">
                <span class="card-title">Controle de acesso</span>
                <span class="card-description"
                  >Gerencie usuários e permissões do sistema.</span
                >
              </div>
            </button>
          </div>
          <div style="display: flex; flex-direction: column; gap: 5px">
            <button
              v-if="handleVerifyUserLevel"
              @click="handleModals('fiscalSettings')"
              class="report-card"
              style="border-left: 3px solid #48b865"
            >
              <div
                class="icon-wrapper"
                style="color: #48b865; background-color: #edfcf2"
              >
                <b-icon-gear></b-icon-gear>
              </div>
              <div class="card-content">
                <span class="card-title">Configurações Adicionais</span>
                <span class="card-description"
                  >Ajustes avançados e personalizações.</span
                >
              </div>
            </button>
            <button
              @click="handleModals('responsible')"
              class="report-card"
              style="border-left: 3px solid #006458"
            >
              <div class="icon-wrapper" style="color: #006458">
                <b-icon-people></b-icon-people>
              </div>
              <div class="card-content">
                <span class="card-title">Responsáveis Tecnicos</span>
                <span class="card-description"
                  >Análise simplificada de pedidos de vendas.</span
                >
              </div>
            </button>
          </div>
        </div>
      </div>

      <div class="content-data-company">
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
            Gerais</span
          >
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.nome"
                @input="company = { key: 'nome', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Nome </label>
            </div>

            <div class="input-group">
              <input
                required
                disabled
                class="input borderInput"
                v-model="company.cpfcnpj"
                @input="
                  company = { key: 'cpfcnpj', value: $event.target.value }
                "
                type="text"
              />
              <label class="fixedSelect2"> CNPJ </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.inscricaoEstadual"
                @input="
                  company = {
                    key: 'inscricaoEstadual',
                    value: $event.target.value,
                  }
                "
                type="text"
              />
              <label class="user-label"> Inscrição Estadual </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.im"
                @input="company = { key: 'im', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Inscrição Municipal </label>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span> <b-icon-geo-alt-fill></b-icon-geo-alt-fill> Localização</span>
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.endereco"
                @input="
                  company = { key: 'endereco', value: $event.target.value }
                "
                type="text"
              />
              <label class="user-label"> Endereço </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.bairro"
                @input="company = { key: 'bairro', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Bairro </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.numero"
                @input="company = { key: 'numero', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Numero </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.complemento"
                @input="
                  company = { key: 'complemento', value: $event.target.value }
                "
                type="text"
              />
              <label class="user-label"> Complemento </label>
            </div>
          </div>
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.cidade"
                @input="company = { key: 'cidade', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Cidade </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.uf"
                @input="company = { key: 'uf', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> UF </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.cep"
                @input="company = { key: 'cep', value: $event.target.value }"
                maxlength="9"
              />
              <label class="user-label"> CEP </label>
            </div>
            <div class="input-group">
              <button class="bcsCep" @click="fetchCep(company.cep)">
                <b-spinner
                  v-if="spinGeneral"
                  small
                  label="Small Spinner"
                ></b-spinner>
                <b-icon-search />
                Buscar CEP
              </button>
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span> <b-icon-telephone-fill></b-icon-telephone-fill> Contatos</span>
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.email"
                @input="company = { key: 'email', value: $event.target.value }"
                type="text"
              />
              <label class="user-label"> Email </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.telefone"
                @input="
                  company = { key: 'telefone', value: $event.target.value }
                "
                v-mask="maskTelefone"
                type="text"
              />
              <label class="user-label"> Telefone </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="company.celular"
                @input="
                  company = { key: 'celular', value: $event.target.value }
                "
                v-mask="maskCelular"
                type="text"
              />
              <label class="user-label"> Celular </label>
            </div>
          </div>

          <div class="mt-2 d-flex justify-content-end">
            <b-button class="btnGeneral" size="sm" @click="update"
              >Salvar</b-button
            >
          </div>
        </div>
      </div>

      <b-modal size="sm" id="modalManagementCompany" hide-header hide-footer>
        <ManagementCompany v-if="handleVerifyUserLevel" />
      </b-modal>

      <b-modal
        id="modal-support-art-password"
        hide-header
        hide-footer
        centered
        @hidden="!supportUnlocked && (supportPassword = '')"
      >
        <div class="support-art-content">
          <h5 class="support-art-title">Acesso do suporte</h5>
          <form @submit.prevent="unlockSupportArt">
            <div class="support-art-field">
              <label for="support-art-password">Senha do suporte</label>
              <input
                id="support-art-password"
                v-model="supportPassword"
                type="password"
                class="support-art-input"
                autocomplete="off"
                required
              />
            </div>
            <div class="support-art-actions">
              <button
                type="button"
                class="support-art-btn support-art-btn-secondary"
                @click="$bvModal.hide('modal-support-art-password')"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="support-art-btn support-art-btn-primary"
                :disabled="supportLoading"
              >
                <b-spinner v-if="supportLoading" small />
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </b-modal>

      <b-modal
        id="modal-support-art-search"
        size="lg"
        hide-header
        hide-footer
        centered
        @hidden="clearSupportArt"
      >
        <div class="support-art-content">
          <h5 class="support-art-title">Corrigir ART das receitas</h5>
          <div class="support-art-section">
            <form @submit.prevent="searchSupportArt">
              <div class="support-art-field">
                <label for="support-old-art">ART atual</label>
                <div class="support-art-search-row">
                  <input
                    id="support-old-art"
                    v-model="supportOldArt"
                    type="text"
                    class="support-art-input"
                    maxlength="25"
                    required
                  />
                  <button
                    type="submit"
                    class="support-art-btn support-art-btn-primary"
                    :disabled="supportLoading"
                  >
                    <b-spinner v-if="supportLoading" small />
                    <b-icon-search v-else /> Pesquisar
                  </button>
                </div>
                <small
                  >Digite exatamente como foi cadastrada, inclusive com espaços
                  no início.</small
                >
              </div>
            </form>
          </div>

          <div v-if="supportResult" class="support-art-section">
            <p class="support-art-summary">
              {{ supportResult.total }}
              {{
                supportResult.total === 1
                  ? "receita encontrada"
                  : "receitas encontradas"
              }}
              para <code>{{ JSON.stringify(supportSearchedArt) }}</code>
            </p>
            <template v-if="supportResult.total">
              <div class="support-art-results">
                <table class="support-art-table">
                  <thead>
                    <tr>
                      <th>Venda</th>
                      <th>Receita</th>
                      <th>Responsável</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in supportResult.prescriptions"
                      :key="item.id"
                    >
                      <td>{{ item.numero }}</td>
                      <td>{{ item.receita }}</td>
                      <td>{{ item.responsavel || "-" }}</td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <small
                v-if="supportResult.total > 50"
                class="support-art-table-note"
                >Exibindo as primeiras 50 receitas. A correção incluirá todas as
                {{ supportResult.total }} encontradas.</small
              >
            </template>
          </div>

          <div
            v-if="supportResult && supportResult.total"
            class="support-art-section"
          >
            <div class="support-art-field">
              <label for="support-new-art">Nova ART</label>
              <input
                id="support-new-art"
                v-model="supportNewArt"
                type="text"
                class="support-art-input"
                maxlength="25"
              />
            </div>
            <small class="support-art-note"
              >A ART do responsável técnico não será alterada.</small
            >
            <div class="support-art-actions">
              <button
                type="button"
                class="support-art-btn support-art-btn-secondary"
                @click="$bvModal.hide('modal-support-art-search')"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="support-art-btn support-art-btn-primary"
                :disabled="supportLoading || !supportNewArt.trim()"
                @click="replaceSupportArt"
              >
                <b-spinner v-if="supportLoading" small />
                Atualizar {{ supportResult.total }}
                {{ supportResult.total === 1 ? "receita" : "receitas" }}
              </button>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modal-tester"
        hide-footer
        hide-header
        centered
        title="inicial"
      >
        <h6 class="titleModal">
          <img class="alertImg" :src="alert" />
        </h6>
        <div class="contentModal">
          <div class="textTester">
            <p>Você não possui licenças no modo teste!</p>
            <p>Adquira seu plano para liberar essa funcionalidade.</p>
            <ul>
              <li>Whatsapp 1: (31) 3891-9414</li>
              <li>Whatsapp 2 (31) 99561-4589</li>
              <li>Email: suporte@bmssoftwares.com.br</li>
            </ul>
          </div>
        </div>
      </b-modal>
    </div>

    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModal" @click="modalHeight"> X </b-button>
        <Permission
          v-if="handleVerifyUserLevel && enableModalsSettings.accessControl"
        />

        <Settings v-if="enableModalsSettings.fiscalSettings" />

        <LogsScreen v-if="enableModalsSettings.logsScreen" />

        <div
          v-if="enableModalsSettings.responsible"
          style="padding: 2rem 2rem 0 2rem"
        >
          <div class="carroselCtn">
            <div class="StatementOnAccount">
              <label
                v-for="item in tabs"
                :key="item.text"
                class="StatementOnAccountItem"
                :class="{ active: selectedTabLabel === item.value }"
                @click="storeLabelTabName(item.text)"
              >
                {{ item.text }} <br />
              </label>
            </div>
          </div>

          <Responsible
            v-show="selectedTabLabel === 'Cadastro'"
            :clearAll="isClearResponsible"
          />

          <div
            v-show="selectedTabLabel === 'Pesquisar'"
            class="generalTableItem"
          >
            <div class="titleGeneralRegisters">
              <b-button
                class="BtnRegister"
                style="background: #344d67"
                name="responsible"
                @click="handleClickNewResponsible"
              >
                <b-icon-plus scale="1.5"></b-icon-plus>
                Novo Responsável Técnico</b-button
              >
            </div>

            <ResponsibleTable
              @clickEditResponsible="selectedTabLabel = 'Cadastro'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinSettingsCompany from "../../mixins/Settings/Company";
import ServiceSupportArt from "../../services/serviceSupportArt";

export default {
  mixins: [mixinSettingsCompany],
  data() {
    return {
      supportPassword: "",
      supportOldArt: "",
      supportSearchedArt: "",
      supportNewArt: "",
      supportResult: null,
      supportLoading: false,
      supportUnlocked: false,
    };
  },
  watch: {
    supportOldArt() {
      this.supportResult = null;
      this.supportNewArt = "";
    },
  },
  methods: {
    supportError(error) {
      this.$toast.open({
        message:
          error?.response?.data?.message ||
          "Não foi possível concluir a operação.",
        type: "error",
      });
    },
    async unlockSupportArt() {
      try {
        this.supportLoading = true;
        await ServiceSupportArt.unlock(this.supportPassword);
        this.supportUnlocked = true;
        this.$bvModal.hide("modal-support-art-password");
        this.$bvModal.show("modal-support-art-search");
      } catch (error) {
        this.supportError(error);
      } finally {
        this.supportLoading = false;
      }
    },
    async searchSupportArt() {
      if (!this.supportOldArt.trim()) return;
      try {
        this.supportLoading = true;
        const oldArt = this.supportOldArt;
        const result = await ServiceSupportArt.search(
          this.supportPassword,
          oldArt
        );
        if (oldArt !== this.supportOldArt) return;
        this.supportSearchedArt = oldArt;
        this.supportResult = result;
        this.supportNewArt = "";
      } catch (error) {
        this.supportError(error);
      } finally {
        this.supportLoading = false;
      }
    },
    async replaceSupportArt() {
      if (
        !this.supportResult?.total ||
        this.supportSearchedArt !== this.supportOldArt ||
        !this.supportNewArt.trim() ||
        this.supportNewArt.trim() === this.supportOldArt
      )
        return;

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Substituir a ART ${JSON.stringify(
          this.supportOldArt
        )} por ${JSON.stringify(this.supportNewArt.trim())} em ${
          this.supportResult.total
        } receitas?`,
        {
          title: "Confirmar correção de ART",
          okVariant: "danger",
          okTitle: "Atualizar",
          cancelTitle: "Cancelar",
        }
      );
      if (!confirmed) return;

      try {
        this.supportLoading = true;
        const { updated } = await ServiceSupportArt.replace(
          this.supportPassword,
          this.supportSearchedArt,
          this.supportNewArt,
          this.supportResult.total
        );
        this.$toast.open({
          message: `${updated} receitas atualizadas com sucesso.`,
          type: "success",
        });
        this.clearSupportArt();
        this.$bvModal.hide("modal-support-art-search");
      } catch (error) {
        this.supportResult = null;
        this.supportError(error);
      } finally {
        this.supportLoading = false;
      }
    },
    clearSupportArt() {
      this.supportUnlocked = false;
      this.supportPassword = "";
      this.supportOldArt = "";
      this.supportSearchedArt = "";
      this.supportNewArt = "";
      this.supportResult = null;
    },
  },
};
</script>

<style scoped>
.support-art-content {
  font-size: 12px;
  color: #5c5855;
}

.support-art-title {
  margin: 0 0 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
  color: #006256;
  font-size: 16px;
  font-weight: 600;
}

.support-art-section + .support-art-section {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #e6e6e6;
}

.support-art-field label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #006256;
}

.support-art-field small,
.support-art-table-note,
.support-art-note {
  display: block;
  margin-top: 5px;
  color: #666;
  font-size: 11px;
}

.support-art-input {
  width: 100%;
  min-width: 0;
  height: 30px;
  padding: 0 7px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  color: #5c5855;
  font-size: 12px;
}

.support-art-input:focus {
  border-color: #505050;
}

.support-art-search-row {
  display: flex;
  gap: 10px;
}

.support-art-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 30px;
  padding: 4px 12px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.support-art-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.support-art-btn-primary {
  background: #006458;
  color: #fff;
}

.support-art-btn-primary:not(:disabled):hover {
  background: #004f46;
}

.support-art-btn-secondary {
  border-color: #d7d7d7;
  background: #d7d7d7;
  color: #333;
}

.support-art-btn-secondary:hover {
  background: #c9c9c9;
}

.support-art-actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 15px;
}

.support-art-summary {
  margin: 0 0 10px;
}

.support-art-summary code {
  white-space: pre-wrap;
  word-break: break-all;
}

.support-art-results {
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #e6e6e6;
}

.support-art-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.support-art-table th,
.support-art-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.support-art-table th {
  position: sticky;
  top: 0;
  background: #f9f9f9;
  color: #006256;
  font-size: 12px;
  font-weight: 600;
}

.support-art-table tr:last-child td {
  border-bottom: 0;
}

@media (max-width: 575px) {
  .support-art-search-row {
    flex-direction: column;
  }

  .support-art-table th,
  .support-art-table td {
    padding: 8px 6px;
    font-size: 11px;
  }
}
.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModal {
  position: fixed;
  top: 51px;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModal:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.generalContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.titleModal {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 3px solid rgb(238, 238, 238);
  justify-content: center;
}

.btnModal {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 55%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.contentModal {
  font-size: 13px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}

.textContact {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.textContact ul {
  font-size: 11px;
  list-style: circle;
}

.textContact p {
  width: 90%;
  text-align: center;
}
.textTester {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.textTester ul {
  font-size: 12px;
  list-style: circle;
}

.textTester p {
  width: 90%;
  text-align: center;
}

.footerBtnFiscal {
  display: flex;
  justify-content: space-around;
}

.contentConfFiscal {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.alertImg {
  width: 100px;
  height: 100px;
}

.contentImg {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.header-logo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.StatementOnAccount {
  display: flex;
  align-items: center;
  height: 30px;
  width: 100%;
  gap: 1px;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 10px;
  background: #eeeeee;
  color: #000000;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 35px;
  background-color: #006458;
  color: white;
  border-bottom: 2px solid white;
  padding-bottom: 5px;
  border-radius: 10px 10px 0 0;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #006458;
  color: white;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.generalTableItem {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  margin-top: 5px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: #f4f4f4;
  height: calc(100vh - 150px);
}

.titleGeneralRegisters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
}

.BtnRegister {
  position: absolute;
  right: 40px;
  top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background: whitesmoke;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
}

.BtnRegister:hover {
  background: whitesmoke;
  box-shadow: none;
}

.content-btn {
  display: flex;
  gap: 20px;
  width: 60%;
}

.celBtn {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.BtnCompany {
  border: none;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.logo {
  height: 135px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.logo__img {
  max-height: 120px;
  max-width: 200px;
}

.logo img {
  height: 120px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
  border-radius: 3px;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

.content-data-company {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

#input_file {
  display: none;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

@media screen and (max-width: 1028px) {
  .generalContent {
    flex-direction: column;
    gap: 20px;
  }
  .contentImg {
    justify-content: center;
    align-items: center;
  }
}

span {
  font-weight: bold;
  cursor: context-menu;
  font-size: 13px;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  top: -20px;
  font-size: 13px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  padding: 5px;
  background: white;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.bcsCep {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 30px;
  font-size: 12px;
  gap: 3px;
  cursor: pointer;
  color: #006458;
  border: 1px solid #006458;
  border-radius: 5px;
  background: #f3f3f3;
  align-items: center;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.borderInputFile {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
  padding: 0.1rem;
}

.borderInputFile:focus {
  border: 1px solid #505050;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 6px;
  width: 100%;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.contentEmailAndResume {
  width: 100%;
  display: flex;
  gap: 1rem;
}

.report-card {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  padding: 16px 10px 16px 10px;
  text-align: left;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.015);
  outline: none;
}

.report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e1;
}

.reports-wrapper {
  border-radius: 0 28px 28px 28px;
  padding: 5px 15px 10px 15px;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  background-color: #f8fafc;
  margin-bottom: 20px;
}

.cards-grid {
  display: flex;
  gap: 10px;
  margin-left: 10px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background-color: #edfcf2;
  color: #22c55e;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  font-size: 16px;
}

.card-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 8px;
}

.card-title {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 2px;
}

.card-description {
  font-size: 11px;
  color: #64748b;
  line-height: 1.4;
}

.card-arrow {
  color: #94a3b8;
  font-size: 14px;
  flex-shrink: 0;
  margin-left: auto;
}
.btnGeneral {
  border-radius: 5px;
  background-color: #006458;
  width: 165px;
  border: none;
  font-size: 12px;
  border: 1px solid rgb(29, 120, 21);
}

.btnGeneral:hover {
  background-color: rgb(233, 255, 223);
  color: rgb(29, 120, 21);
}

.btnCancel {
  background-color: rgb(172, 55, 55);
  color: white;
}

.btnCancel:hover {
  background-color: rgb(144, 45, 45);
  color: white;
}

.btnsUpdateCertificate {
  text-align: center;
  padding: 0.5rem;
  border-radius: 5px;
  background-color: whitesmoke;
  width: 100%;
  border: none;
  color: rgb(29, 120, 21);
  font-size: 12px;
  border: 1px solid rgb(29, 120, 21);
  cursor: pointer;
}

.btnsUpdateCertificate:hover {
  background-color: rgb(233, 255, 223);
  color: rgb(29, 120, 21);
}

.input-group {
  width: 30%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 0 0 1rem;
  padding-left: 0 !important;
}

.card {
  border: none !important;
}

/* INPUT FILE */

.contentBtnsCertificate {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.contentInputFile {
  display: flex;
  gap: 5px;
  align-items: center;
}

input[type="file"] {
  display: none;
}

.labelInputFile {
  width: 400px;
  min-width: 400px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  cursor: pointer !important;
  margin: 0;
}

.textSelectFile {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
  background-color: #c1c1c156;
  border-radius: 5px;
  font-weight: bold;
  font-size: 11px;
  padding: 5.75px 9px;
  cursor: pointer;
}

.textSelectFile p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.textDropFile {
  max-width: 230px !important;
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  cursor: pointer;
}

/* INPUT FILE */

.contentCertificateAndVirtualManager {
  width: 100%;
  display: flex;
  gap: 1rem;
}

.containerCertificate {
  width: 40%;
  min-width: 420px;
}

.contentCertificateExpiration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  background-color: rgb(62, 102, 174);
  color: white;
  padding: 0.25rem;
  border-radius: 5px;
}

.contentCertificateExpiration span {
  font-weight: normal;
}

.contentCertificateExpiration p {
  padding: 0 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  margin: 0;
  font-weight: normal;
  background-color: rgb(187, 31, 31);
  border-radius: 5px;
  font-size: 14px;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9.5px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.rowCertificate {
  justify-content: center;
}

.containerCertificateExpiration {
  max-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 0 2.5px 0 rgba(0, 0, 0, 0.545);
}

.contentLoading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
}

.loading {
  width: 100px;
  height: 100px;
}

.contentActiveVirtualManager {
  min-width: 179px;
  display: flex;
}

.contentActiveVirtualManager label {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  color: #006256;
  border-radius: 5px;
  gap: 15px;
  color: #006256;
  background-color: whitesmoke;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.135);
  padding: 5px;
  cursor: pointer;
}

.contentActiveVirtualManager input {
  width: 18px !important;
  height: 18px !important;
  cursor: pointer;
}

.selectPlus {
  position: relative;
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.selectPlus1 {
  position: relative;
  width: 20%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .generalContent {
    gap: 5px;
  }
  .content-btn {
    gap: 10px;
    width: 35%;
  }
  .contentImg {
    padding: 10px 0px;
    margin-bottom: 0px;
    width: 50%;
  }
  .user-label-ob {
    left: 7px;
    font-size: 12px;
  }
  .BtnCompany {
    font-size: 11px;
  }
  .rowContainer {
    padding: 5px;
  }
  .rowContainer span {
    font-size: 12px;
  }
  .rowContent {
    padding: 5px 0 5px 0;
    gap: 5px;
  }
  .containerCertificateExpiration {
    gap: 0px;
    padding: 5px;
  }
  .btnsUpdateCertificate {
    padding: 5px;
    font-size: 11px;
  }
}

@media screen and (max-width: 1150px) and (min-width: 930px) {
  .selectPlus {
    min-width: 120px;
  }
}

@media screen and (max-width: 930px) and (min-width: 750px) {
  .contentEmailAndResume {
    flex-direction: column;
  }

  .selectPlus {
    width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .user-label-ob {
    top: 90px;
  }
  .selectPlus {
    min-width: 120px;
  }

  .ModalGeneral {
    width: 100%;
    left: 0;
    top: 0;
    height: 100% !important;
    max-height: 100%;
  }

  .closeModal {
    top: 8px;
    right: 10px;
  }

  .summaryForm {
    padding: 2rem 1rem 1rem 1rem !important;
  }

  .header-logo {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .content-btn {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    width: 40%;
    justify-content: center;
  }
}

@media screen and (max-width: 750px) {
  .contentCertificateAndVirtualManager {
    flex-direction: column;
  }

  .containerCertificate,
  .contentInputFile,
  .labelInputFile {
    width: 100%;
    min-width: 100%;
  }
}

@media screen and (max-width: 430px) {
  .contentBtnsCertificate div,
  .btnSendCertificate,
  .btnCancel {
    width: 100% !important;
  }

  .contentBtnsCertificate {
    gap: 1rem;
  }

  .contentEmailAndResume {
    flex-direction: column;
  }

  .selectPlus {
    width: 100%;
  }
}

@media screen and (max-width: 650px) {
  .contentImg {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 5px;
    padding: 20px 10px;
    margin-bottom: 10px;
    width: auto;
  }
  .logo {
    height: 100px;
    width: 170px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }

  .rowContent {
    flex-direction: column;
  }

  .input-group {
    width: 100%;
  }

  .selectPlus1 {
    width: 100%;
  }
}
</style>
